<!--
        Las paginas para administrar Roles
-->

<div class="page" id="role-collection-page">
    <div class="action-bar dark-bg with-tabs">
            <div class="title">Roles</div>
            <div class="tabs">
                <a class="tab" href="#roles?estado=A">Activos</a>
                <a class="tab" href="#roles?estado=I">Inactivos</a>
                <a class="tab" href="#roles?estado=X">Eliminados</a>
                <a class="tab" href="#roles?estado=*">Todos</a>
            </div>
            <div class="actions-set">
                <a class="action-btn back" href="#home"></a>
                <a class="action-btn search" href="#"></a>
                <a class="action-btn add" href="#rol?id=nuevo">Agregar un nuevo rol</a>
                <a class="action-btn sos" href="#">SOS</a>
            </div>
    </div>
    <div class="content">
        <div class="container">
            <div class="section" id="roles">
                <div class="list-content"></div>
            </div>
        </div>
    </div>
</div>

<div class="page legacy-page overlayed" id="role-page">
    <div class="action-bar dark-bg">
        <div class="title no-margin">
            Rol:
        </div>
        <div class="actions-set">
            <a class="action-btn done SaveBtn" href="#"></a>
            |
            <a class="action-btn delete" href="#"></a>
            <a class="action-btn sos" href="#">SOS</a>
        </div>
    </div>
    <div class="page-overlay"></div>
    <div class="content with-sidebar">
        <div class="legacy-sidebar">
            <h4>Otros roles</h4>
            <div class="pane cache"></div>
        </div>
        <div class="container legacy-container">
            <div class="section" id="rol">
            <form class="legacy-form" id="new-role-form">
                <a class="action-btn CancelBtn" icon="cancel" href="#roles?estado=A"></a>
                <h2 class="StringCtrl required" property="title">
                    <input type="text" size=32 placeholder="Rol ?"/>
                    <p class="hint">
                    Ingresa aquí un nombre descriptivo del <b>Rol</b> que esta persona cuple en tu Empresa o tu Grupo. 
                    Este campo es necesario.
                    A continuación puedes agregar otra información útil asociada al Rol.
                    </p>
                </h2>
                <br/>
                <ul>
                    <li>
                       <a class="aside" ref="#que-son-los-roles">Qué son los Roles ?</a>
                       &nbsp;
                       <a class="aside">Como puedo usarlos ?</a>
                       <br><br>
                       <p class="aside-content hidden" id="que-son-los-roles">
                       Los roles permiten definir funciones y responsabilidades dentro de la
                       empresa (por ejemplo: "Gte de Ventas", "Vendedor", y después asignarlas a personas específicas.
                       </p>
                    </li>
                    <li class="SelectCtrl" property="state">
                        <label>Estado</label>
                        <select>
                            <option value="A">Activo</option>
                            <option value="I">Inactivo</option>
                            <option value="X">Eliminado</option>
                        </select>
                    </li>
                    <li class="StringCtrl" property="descr">
                        <label>Descripción</label>
                        <input type="text" size=38/>
                    </li>
                </ul>
                <p class="form-buttons">
                        <button class="accept CreateBtn">AGREGAR ESTE NUEVO ROL</button>
                        <button class="accept SaveBtn">GUARDAR LOS CAMBIOS</button>
                </p>
            </form>
            </div>
        </div>
    </div>
</div>

<script>
import { onMount } from 'svelte'

onMount(() => {
  window.$("#role-page").RolePage("#rol") ;
  window.$("#role-collection-page").RolesCollectionPage("#roles") ;
})
</script>
